import { createContext, useContext } from 'react';
import { useStore } from 'zustand';
import type { StreamState, StreamStore } from './streamStore';

export const StreamContext = createContext<StreamStore | null>(null);

export function useStreamStore(): StreamStore {
  const store = useContext(StreamContext);
  if (!store) throw new Error('StreamProvider is missing');
  return store;
}

/** Select a slice of the live state; the component re-renders only when that slice changes. */
export function useStream<T>(selector: (state: StreamState) => T): T {
  return useStore(useStreamStore(), selector);
}
